export const DOCUMENT_MODAL_EDITOR_KEY = 'DOCUMENT-MODAL';
export const DOCUMENT_MODAL_TITLE_EDITOR_KEY = 'DOCUMENT-MODAL-TITLE';
